import {
  addIcon,
  addIcon2,
  analysisIcon,
  dratIcon,
  helpIcon,
  KSAIcon,
  listIcon,
  logoutIcon,
  notificationIcon2,
  priceIcon,
  USAIcon,
} from "assets/icons";
import { getFromLocal, setToLocal } from "config/axiosInstance";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setUserInfo } from "../../store/slices/userInfoSlice";
import { userDetailsApi } from "services/userProfile";
import { getValueOrFallback, profileImageHandler } from "utils/commonHelper";
import LogoutModal from "../modals/LogoutModal";
import { masterRegionList } from "services/master";
import { setRegionList } from "store/slices/regionListSlice";
import { extractUserDetail } from "constant/staticData";
import { FaBell, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Notification from "./Notification";

const menuItems = [
  {
    key: "createSurveys",
    icon: addIcon2,
    label: "Create  ",
    link: "/dashboard/create-survey",
    disabled: false,
  },
  {
    key: "mySurveys",
    icon: listIcon,
    label: "My Surveys",
    link: "/dashboard/surveys",
    disabled: false,
  },
  // {
  //   key: "myDraft",
  //   icon: dratIcon,
  //   label: "My Draft",
  //   link: "/dashboard/draft-surveys",
  //   disabled: false,
  // },
  {
    key: "analysis",
    icon: analysisIcon,
    label: "Analysis",
    link: "/dashboard/analysis",
    disabled: false,
  },
  {
    key: "support",
    icon: helpIcon,
    label: "Support",
    link: "/dashboard/support",
    disabled: false,
  },
  {
    key: "pricing",
    icon: priceIcon,
    label: "Pricing",
    link: "/dashboard/pricing",
    disabled: false,
  },
];

const Avatar = () => {
  const token = getFromLocal("token");
  // Set All Value
  const [logoutModal, setLogoutModal] = useState(false);
  const [language, setLanguage] = useState(i18next?.language || "en");
  const { i18n, t } = useTranslation();

  const menuItems = [
    {
      key: "createSurveys",
      icon: addIcon2,
      label: t("SIDEMENU.create"),
      link: "/dashboard/create-survey",
      disabled: false,
    },
    {
      key: "mySurveys",
      icon: listIcon,
      label: t("SIDEMENU.mySurvey"),
      link: "/dashboard/surveys",
      disabled: false,
    },
    // {
    //   key: "myDraft",
    //   icon: dratIcon,
    //   label: "My Draft",
    //   link: "/dashboard/draft-surveys",
    //   disabled: false,
    // },
    {
      key: "analysis",
      icon: analysisIcon,
      label: t("SIDEMENU.analysis"),
      link: "/dashboard/analysis",
      disabled: false,
    },
    {
      key: "support",
      icon: helpIcon,
      label: t("SIDEMENU.support"),
      link: "/dashboard/support",
      disabled: false,
    },
    {
      key: "pricing",
      icon: priceIcon,
      label: t("SIDEMENU.pricing"),
      link: "/dashboard/pricing",
      disabled: false,
    },
  ];

  const getLanguage = (language) => {
    const languageObject = {
      en: {
        icon: USAIcon,
        label: "English",
      },
      ar: {
        icon: KSAIcon,
        label: "Arabic",
      },
    };

    return languageObject[language] || languageObject["en"];
  };

  // call Hooks
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userInfo);

  // close logout modal
  const closeLogoutModal = () => {
    setLogoutModal(false);
  };

  // Fetching User Details API
  const fetchingUserDetails = async () => {
    if (token) {
      try {
        const reqData = { token: token };
        const responseData = await userDetailsApi(reqData);
        const {
          data: { userDetail = {} },
          status,
        } = responseData;
        if (status === 200) {
          const selectedUserDetail = extractUserDetail(userDetail);
          dispatch(setUserInfo(selectedUserDetail));
        }
      } catch (e) {
        console.log("Error:", e.message);
      }
    }
  };

  // Region List
  const fetchRegionList = async (language) => {
    try {
      const responseData = await masterRegionList(language);
      const {
        data: { region = {} },
        status,
      } = responseData;
      if (status === 200) {
        dispatch(setRegionList(region));
      }
    } catch (e) {
      console.log("Error:", e.message);
    }
  };

  useEffect(() => {
    fetchingUserDetails();
  }, [token]);

  useEffect(() => {
    if (i18n.language) {
      fetchRegionList(i18n.language);
    }
  }, [i18n.language]);

  const handleLanguageChange = (selectedLanguage) => {
    setToLocal("i18nLng", selectedLanguage, null);
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);

  return (
    <>
      <div className="header_avatar">
        {/* Notification Icon */}
        <Notification />
        <Dropdown className="customDropdown language_dropdown">
          <Dropdown.Toggle id="dropdown-basic">
            <img src={getLanguage(language)?.icon} alt="" />{" "}
            <span>{getLanguage(language)?.label}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => handleLanguageChange("en")}
              // href="#/action-1"
            >
              <img src={USAIcon} alt="" /> <span>EN</span>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleLanguageChange("ar")}
              // href="#/action-2"
            >
              <img src={KSAIcon} alt="" /> <span>AR</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown className="customDropdown userProfile_dropdown">
          <Dropdown.Toggle id="dropdown-basic">
            <img
              src={
                userInfo?.profileUrl || profileImageHandler(userInfo?.gender)
              }
              alt="user-profile"
            />
            <p>
              <b>{getValueOrFallback(userInfo?.firstName)}</b>
              <span>{t("SIDEMENU.researcher")}</span>
            </p>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <div className="detail">
              <img
                src={
                  userInfo?.profileUrl || profileImageHandler(userInfo?.gender)
                }
                alt="user-profile"
              />
              <p>
                <b>{getValueOrFallback(userInfo?.firstName)}</b>
                <span>{t("SIDEMENU.researcher")}</span>
                <Link to="/dashboard/profile/edit">
                  {t("SIDEMENU.editProfile")}
                </Link>
              </p>
            </div>
            <div className="setup_profile">
              <Dropdown.Item as={"div"}>
                <p>{t("SIDEMENU.finishSettingUpProfile")}</p>
                <Link to="/dashboard/profile/edit" className="button">
                  {t("SIDEMENU.setProfile")}
                </Link>
              </Dropdown.Item>
            </div>
            {menuItems.map((item) => (
              <Dropdown.Item
                key={item?.key || ""}
                as="span"
                disabled={item.disabled}
              >
                <Link to={item?.link || ""}>
                  <img src={item?.icon || ""} alt="" />
                  <span>{item?.label || ""}</span>
                </Link>
              </Dropdown.Item>
            ))}
            <Dropdown.Item as={"span"}>
              <button type="button" onClick={() => setLogoutModal(true)}>
                <img src={logoutIcon} alt="" />{" "}
                <span>{t("SIDEMENU.logout")}</span>
              </button>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {logoutModal && (
        <LogoutModal show={logoutModal} closeLogoutModal={closeLogoutModal} />
      )}
    </>
  );
};

export default Avatar;
